<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card header="Lista Global de Requerimientos">
          <div class="table-responsive rqTable">
            <div class="form-group form-inline pull-left">
              <select v-model="numPages" class="form-control">
                <option v-for="(num,k) in [10, 30, 50, 100]" :key="k" :value="num">{{ num }}</option>
              </select>&nbsp;
              <input v-model="search" type="search" class="form-control" placeholder="Buscar">
            </div>
            <div class="form-group form-inline pull-right">
              <date-picker
                v-model="date.start"
                lang="es"
                type="date"
                placeholder="Desde"
                required
                format="DD/MM/YYYY"
              ></date-picker>&nbsp;
              <date-picker
                v-model="date.end"
                lang="es"
                type="date"
                placeholder="Hasta"
                required
                format="DD/MM/YYYY"
              ></date-picker>&nbsp;
              <button class="btn btn-primary" @click="getRqs()">Buscar</button>&nbsp;
              <download-excel
                class="btn btn-primary"
                :data="filteredRqs"
                :fields="json_fields"
                name="PorteosFinalizados.xls"
              >Descargar Excel</download-excel>
            </div>
            <table class="table table-bordered table-hover table-striped">
              <thead>
                <tr>
                  <th>#RQ</th>
                  <th>Operación</th>
                  <th>Nave</th>
                  <th>Recalada</th>
                  <th>Puerto</th>
                  <th>Cita</th>
                  <th>Placa</th>
                  <th>Transporte</th>
                  <th>Conductor</th>
                  <th>Tipo de carga</th>
                  <th>Contenedor(es)</th>
                  <th>Revisión SINI</th>
                  <th>Estado</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(rq,k) in paginated('filteredRqs')"
                  :key="k"
                  @contextmenu.prevent="selectRq(rq)"
                >
                  <td>{{rq.id}}</td>
                  <td>{{rq.operation.name}}</td>
                  <td>{{rq.appointments[0] && rq.appointments[0].container ? rq.appointments[0].container.ship_name : ''}}</td>
                  <td>{{rq.appointments[0] && rq.appointments[0].container ? rq.appointments[0].container.recalada : ''}}</td>
                  <td>{{rq.service.port.name}}</td>
                  <td>{{rq.appointments[0].schedule | formatDateTime}}</td>
                  <td>{{rq.truck ? rq.truck.plate : ''}}</td>
                  <td>{{rq.truck && rq.truck.provider ? rq.truck.provider.name : ''}}</td>
                  <td>{{rq.driver ? `${rq.driver.name} ${rq.driver.last_name}` : '' }}</td>
                  <td>{{rq.charge_type.name}}</td>
                  <td>
                    <span v-for="(ap, k) in rq.appointments" :key="k">
                      {{ap.container ? ap.container.number : ''}}
                    </span>
                  </td>
                  <td>{{rq.appointments[0] && rq.appointments[0].container && rq.appointments[0].container.sini ? 'SI' : 'NO'}}</td>
                  <td>{{rq.status.name}}</td>
                </tr>
              </tbody>
            </table>

            <paginate name="filteredRqs" :list="filteredRqs" class="paginate-list" :per="numPages"></paginate>
            <paginate-links
              for="filteredRqs"
              :limit="5"
              :show-step-links="true"
              :step-links="{
                next: '>>',
                prev: '<<'
              }"
              :classes="{
                'ul': 'pagination',
                'li': 'page-item',
                'a': 'page-link',
              }"
            ></paginate-links>
            <context-menu id="context-menu" ref="ctxMenu">
              <li @click="Detail()" class="ctx-item">Ver detalle</li>
            </context-menu>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import api from "@/helpers/api";
import constants from "@/constants";
import moment from "moment";

export default {
  data() {
    return {
      rqs: [],
      paginate: ["filteredRqs"],
      search: "",
      numPages: 100,
      date: {
        start: moment().format("YYYY-MM-DD 00:00"),
        end: moment().format("YYYY-MM-DD 23:59:59")
      },
      showModalEir: false,
      showModalDoc: false,
      doc_eir: "",
      document: "",
      document_name: "",
      json_fields: {
        '#RQ': "id",
        'Operación': 'operation.name',
        'Nave': {
          field: 'appointments',
          callback: appointments => {
            return appointments[0] && appointments[0].container ? appointments[0].container.ship_name : ''
          }
        },
        'Recalada': {
          field: 'appointments',
          callback: appointments => {
            return appointments[0] && appointments[0].container ? appointments[0].container.recalada : ''
          }
        },
        'Puerto': 'service.port.name',
        'Cita': {
          field: 'appointments',
          callback: appointments => {
            return moment(appointments[0].schedule).format("DD/MM/YYYY HH:mm");
          }
        },
        Placa: {
          field: "truck",
          callback: truck => {
            return truck ? truck.plate : ''
          }
        },
        Transporte: {
          field: "truck",
          callback: truck => {
            return truck ? truck.provider.name : ''
          }
        },
        Conductor: {
          field: "driver",
          callback: driver => {
            return driver ? `${driver.name} ${driver.last_name}` : "";
          }
        },
        'Tipo de carga': 'charge_type.name',
        Contenedores: {
          field: 'appointments',
          callback: appointments => {
            let containers = ''
            appointments.map(ap => containers += `${ap.container ? ap.container.number : ''} `);
            return containers
          }
        },
        'Revision SINI': {
          field: "appointments",
          callback: appointments => {
            return appointments[0] && appointments[0].container && appointments[0].container.sini ? 'SI' : 'NO';
          }
        },
        Estado: "status.name",
      },
    };
  },
  computed: {
    filteredRqs() {
      const searchWord = this.search.toLowerCase();
      return this.rqs.filter(rq => {
        let condition = true;
        if (this.search) {

          condition = (rq.appointments[0].container.recalada && rq.appointments[0].container.recalada.toLowerCase().includes(searchWord)) ||
                      (rq.appointments[0].container.ship_name && rq.appointments[0].container.ship_name.toLowerCase().includes(searchWord)) ||
                      (rq.service.port && rq.service.port.name.toLowerCase().includes(searchWord))
          
        }
        return condition;
      });
    }
  },
  mounted() {
    this.constants = constants;
    this.getRqs();
  },
  methods: {
    getRqs() {
      const data = {
        start_schedule: moment(this.date.start).format("YYYY-MM-DD 00:00:00"),
        end_schedule: moment(this.date.end).format("YYYY-MM-DD 23:59:59")
      };
      api.post("portage_finish", data).then(response => {
        this.rqs = response.requeriments;
      });
    },
    selectRq(rq) {
      this.rq = rq;
      this.$refs.ctxMenu.open();
    },
    Detail() {
      let route = this.$router.resolve({path: `/requeriments/detail/${this.rq.id}`});
      window.open(route.href, '_blank');
    }
  }
};
</script>
